import React from 'react';
import Popup from '../../components/Popup';
import getAllReviews from '../../api/queries/reviews/getAllReviews';
import { convertDateToHuman } from '../../utils/common/functions';
import sanitizeHTML from '../../utils/sanitiseHTML';
import createApolloClient from '../../api';

const Blog = ({ data }) => {
  const blogUrl = `https://www.monacosolicitors.co.uk/blog/${data?.postBy?.slug}`;
  const postData = data?.postBy;

  return (
    <>
      <section className="blog__details">
        <div className="blog__details__container">
          {postData?.featuredImage?.node?.sourceUrl && (
            <div className="blog__details__image">
              <img
                src={postData.featuredImage.node.sourceUrl}
                alt={postData.featuredImage.node.altText || ''}
              />
            </div>
          )}
          <h1 className="blog__details__title">{postData?.title}</h1>

          <div className="blog__details__data">
            <div className="blog__details__content">
              <label className="blog__details__content__tag blog__tag">Employee Rights</label>
              <label className="blog__details__content__date blog__date">
                {postData?.author?.node?.name && `By ${postData?.author?.node?.name}`}
                {postData?.date && ` / ${convertDateToHuman(postData?.date)}`}
              </label>
              {postData?.content && (
                <div
                  className="blog__details__content__editor"
                  dangerouslySetInnerHTML={{ __html: sanitizeHTML(postData?.content) }}
                />
              )}
            </div>
            <div className="blog__details__share">
              <label className="">Share</label>
              <ul>
                <li>
                  <a
                    target="blank"
                    href={`https://www.facebook.com/sharer/sharer.php?u=${blogUrl}`}
                  >
                    <img
                      src="https://cdn-icons-png.flaticon.com/512/1051/1051309.png"
                      alt="facebook"
                    />
                  </a>
                </li>
                <li>
                  <a
                    target="blank"
                    href={`https://www.linkedin.com/shareArticle?mini=true&url=${blogUrl}`}
                  >
                    <img src="https://cdn-icons-png.flaticon.com/512/61/61109.png" alt="linkedin" />
                  </a>
                </li>
                <li>
                  <a target="blank" href={`https://twitter.com/intent/tweet?text=${blogUrl}`}>
                    <img
                      src="https://cdn-icons-png.flaticon.com/512/733/733635.png"
                      alt="twitter"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
     <Popup />
    </>
  );
};

export default Blog;

export async function getStaticProps() {
  const client = createApolloClient();
  const customReviewsData = await client.query(getAllReviews());
  return { props: { customReviewsData } };
}
